export const CLIENT_VERSION = 'local-version';
